import React, { useEffect } from "react";
import dreamschoolsLogo from "../../assets/img/redesign-logo.webp";
import "./BillingDayChangeConfirmation.css";

export default function BillingDayChangeConfirmation() {
  useEffect(() => {
    // Old emailed secrets are no longer used; remove them before navigation.
    window.history.replaceState(window.history.state, "", window.location.pathname);
  }, []);
  return <div className="billing-day-confirmation">
    <header className="billing-day-confirmation-header">
      <div className="billing-day-confirmation-header-content">
        <a href="/" aria-label="Dreamschools home" className="billing-day-confirmation-logo">
          <img src={dreamschoolsLogo} alt="Dreamschools" />
        </a>
        <a href="/user" className="billing-day-confirmation-dashboard-link">Parent dashboard</a>
      </div>
    </header>
    <main className="billing-day-confirmation-content">
    <section className="billing-day-confirmation-form" aria-labelledby="billing-day-confirmation-title">
      <h1 id="billing-day-confirmation-title">Billing date updates</h1>
      <p>This confirmation link is no longer used. Organizers now update billing dates directly and send you an email with the details.</p>
      <p>Opening this page does not change your billing schedule. If you received an older request, contact the organizer to check whether the change was made.</p>
      <p>You can view your current payments in your <a href="/user">parent dashboard</a>.</p>
    </section>
    </main>
  </div>;
}
